export default {
  ['title']: '大赛专访',
  ['sub-title']: 'COMPETITION INTERVIEW'
}
